import { FunctionComponent } from 'react';
import styles from './Tab.module.scss';
import { useDatadogLog } from '../../../Input/logging';

type TabProps = {
  variant: 'plain' | 'standard' | 'chart' | 'color' | 'button' | 'dynamic' | 'highlight';
  idx: number;
  label: string;
  isActive?: boolean;
  isDisabled?: boolean;
  icon?: React.JSX.Element;
  isLocked?: boolean;
  tooltip?: React.JSX.Element | null;
  color?: string;
  onClick: (idx: number) => void;
};

type FC = FunctionComponent<TabProps>;

const Tab: FC = ({
  variant,
  idx,
  label = 'Tab',
  isActive = false,
  isDisabled = false,
  icon,
  isLocked,
  tooltip,
  color,
  onClick,
}: TabProps) => {
  const activeClass = isActive ? 'active' : '';
  const disabledClass = isDisabled ? 'disabled' : '';
  const lockedClass = isLocked ? 'locked' : '';
  const log = useDatadogLog();

  const handleClick = () => {
    log({
      message: `${label} tab was clicked`,
      payload: { name: label, value: idx },
      actionType: 'Button',
    });
    if (!isLocked && !isDisabled) {
      onClick(idx);
    }
  };

  return (
    <div
      className={[
        styles.container,
        styles[activeClass],
        styles[disabledClass],
        styles[variant],
        styles[lockedClass],
      ].join(' ')}
      role="button"
      tabIndex={idx}
      aria-hidden="true"
      style={color && isActive ? (variant === 'standard' ? { color } : { background: color }) : {}}
      onClick={handleClick}
    >
      {label}
      {icon && <div style={{ paddingLeft: 10 }}>{icon}</div>}
      {tooltip && tooltip}
    </div>
  );
};

export default Tab;
